"use strict"
import f from "./frames.json"
import p from "./pilot_gear.json"
import s from "./systems.json"

const data = {
  frames: f,
  pilot_gear: p,
  systems: s,
}

export default data;